import { getSvgByName, SpinnerCircular, Typography } from '@repo/ui';
import KitVersionUpdateTooltip from 'components/KitVersionUpdateTooltip/KitVersionUpdateTooltip';
import useKitSystemInfo from 'services/system-info/useKitSystemInfo';
import styles from './KitSectionCardVersion.module.css';

type Props = {
  kitId: string;
};

function UpdateState() {
  return (
    <div className={styles.subContainer}>
      <SpinnerCircular size={12} />
      <Typography
        variant='body-s'
        color='grey'
        className={styles.updateStateLabel}
      >
        Updating...
      </Typography>
    </div>
  );
}

function IconUpdateTooltip({ kitId }: Pick<Props, 'kitId'>) {
  return (
    <KitVersionUpdateTooltip kitId={kitId} position='bottom-center'>
      {getSvgByName('alertCircleFilled')({ className: styles.icon })}
    </KitVersionUpdateTooltip>
  );
}

export default function KitSectionCardVersion({ kitId }: Props) {
  const { prettyVersion, hasOutdatedKitVersion, isUpdating, resultsViewable } =
    useKitSystemInfo(kitId);

  if (
    (!isUpdating && !prettyVersion && !hasOutdatedKitVersion) ||
    !resultsViewable
  )
    return null;

  return (
    <span className={styles.container}>
      •
      {isUpdating ? (
        <UpdateState />
      ) : (
        <div className={styles.subContainer}>
          {prettyVersion}
          {hasOutdatedKitVersion && <IconUpdateTooltip kitId={kitId} />}
        </div>
      )}
    </span>
  );
}
